export class LicenceAdress {
    street      : string;
    number      : string;
    box         : string;
    postalCode  : string;
    municipality: string;

    constructor(street?: string, number?: string, box?: string, postalCode?: string, municipality?: string)
    {
        this.street       = street                       || '';
        this.number       = number === '0' ? '' : number || '';
        this.box          = box                          || '';
        this.postalCode   = postalCode                   || '';
        this.municipality = municipality                 || '';
    }
}
